const dev = {
  PLATFORM: 'prod',
  API_URL: 'http://localhost:3000',
  MEDIA_URL: 'https://cdn.englishworld-learning.fr',
  OBJECT_URL: 'https://cdn.englishworld-learning.fr',
  LRS_ENDPOINT: 'http://localhost:3000/xAPI/',
};

const prod = {
  PLATFORM: 'prod',
  API_URL: 'https://api.englishworld-learning.fr',
  MEDIA_URL: 'https://cdn.englishworld-learning.fr',
  OBJECT_URL: 'https://cdn.englishworld-learning.fr',
  LRS_ENDPOINT: 'https://api.englishworld-learning.fr/xAPI/',
};

const config = process.env.NODE_ENV === 'development' ? dev : prod;

export default config;
